// 監視対象の要素を取得
const animElements = document.querySelectorAll('.anim');

// Intersection Observerの設定
const options = {
  root: null, // ビューポートをルートとして使用
  rootMargin: '-100px', // ビューポートの境界線
  threshold: 0 // 要素がx%表示されたときに発火
};

// コールバック関数
const callback = (entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('inview');
      // 一度表示されたら監視を解除（必要に応じて）
      observer.unobserve(entry.target);
    }
  });
};

// Intersection Observerのインスタンスを作成
const observer = new IntersectionObserver(callback, options);

// 各要素の監視を開始
animElements.forEach(element => {
  observer.observe(element);
});